<template>
  <div>
    <h1 :class="$style.pageTitle">ツール</h1>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div v-if="loading" class="text-center">
              <a-spin tip="Loading..." />
            </div>
            <div v-if="!loading">
              <!-- ユーザーID検索 -->
              <a-form layout="inline" style="margin-bottom: 20px;">
                <a-form-model-item ref="user_id" label="ユーザーID" prop="user_id">
                  <a-input-number v-model="userId" :min="0" />
                </a-form-model-item>
                <a-form-item>
                  <a-button @click="searchUser" type="primary">検索</a-button>
                </a-form-item>
              </a-form>
              <div v-if="gotUserId">
                <p>ユーザーID: {{ user.id }}</p>
                <p>ユーザー名: {{ user.name }}</p>
                <p>会社名（ID）: {{ user.company_name }}({{ user.company_id }})</p>
                <p>メールアドレス: {{ user.email }}</p>
                <p>bounce_flag: {{ user.bounce_flag }}</p>
                <p class="float-right">
                  <a-button @click="openUserInfoModal(1, user)" style="margin-right: 10px;">メールアドレス変更</a-button>
                  <a-button @click="openUserInfoModal(2, user)" style="margin-right: 10px;">パスワード変更</a-button>
                  <a-button @click="openBounceModal('user', user.id, user.bounce_flag)">bounce_flag 変更</a-button>
                </p>
              </div>

              <a-divider />

              <!-- メールアドレス検索 -->
              <a-form layout="inline" style="margin-bottom: 20px;">
                <a-form-model-item label="メールアドレス">
                  <a-input v-model="emailQuery" style="width: 300px;" placeholder="example@example.com" />
                </a-form-model-item>
                <a-form-item>
                  <a-button @click="searchByEmail" type="primary" :loading="emailSearchLoading">検索</a-button>
                </a-form-item>
              </a-form>

              <div v-if="emailSearchDone">
                <div v-if="!emailResult.user && !emailResult.notice_email_address">
                  <p>該当するレコードがありません</p>
                </div>

                <!-- メール検索結果: ユーザー -->
                <div v-if="emailResult.user" style="margin-bottom: 20px;">
                  <h5>ユーザー</h5>
                  <p>ユーザーID: {{ emailResult.user.id }}</p>
                  <p>ユーザー名: {{ emailResult.user.name }}</p>
                  <p>会社名（ID）: {{ emailResult.user.company_name }}({{ emailResult.user.company_id }})</p>
                  <p>メールアドレス: {{ emailResult.user.email }}</p>
                  <p>bounce_flag: {{ emailResult.user.bounce_flag }}</p>
                  <p class="float-right">
                    <a-button @click="openUserInfoModal(1, emailResult.user)" style="margin-right: 10px;">メールアドレス変更</a-button>
                    <a-button @click="openUserInfoModal(2, emailResult.user)" style="margin-right: 10px;">パスワード変更</a-button>
                    <a-button @click="openBounceModal('user', emailResult.user.id, emailResult.user.bounce_flag)">bounce_flag 変更</a-button>
                  </p>
                </div>

                <!-- メール検索結果: 通知メールアドレス -->
                <div v-if="emailResult.notice_email_address" style="margin-top: 20px;">
                  <h5>通知メールアドレス</h5>
                  <p>メールアドレス: {{ emailResult.notice_email_address.email }}</p>
                  <p>会社名（ID）: {{ emailResult.notice_email_address.company_name }}({{ emailResult.notice_email_address.company_id }})</p>
                  <p>bounce_flag: {{ emailResult.notice_email_address.bounce_flag }}</p>
                  <p class="float-right">
                    <a-button @click="openBounceModal('nea', emailResult.notice_email_address.id, emailResult.notice_email_address.bounce_flag)">bounce_flag 変更</a-button>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- メール/パスワード変更モーダル -->
    <a-modal
      :title="changeUserInfo"
      :visible="visibleUserInfo"
      @cancel="handleCancelUserInfo"
    >
      <div>
        <a-form-model>
          <a-form-model-item ref="newStr" :label="changeUserLabel" prop="newStr">
            <a-input v-model="newStr" />
          </a-form-model-item>
        </a-form-model>
      </div>
      <template slot="footer">
        <div class="clearfix">
          <div class="float-right">
            <a-button key="back" @click="handleCancelUserInfo">
              キャンセル
            </a-button>
            <a-button key="submit" type="primary" :loading="confirmUserInfoUpdateLoading" @click="handleOkUserInfoUpdate">
              更新する
            </a-button>
          </div>
        </div>
      </template>
    </a-modal>

    <!-- bounce_flag 変更モーダル -->
    <a-modal
      title="bounce_flag 変更"
      :visible="bounceModal.visible"
      @cancel="handleCancelBounce"
    >
      <div>
        <a-form-model>
          <a-form-model-item label="bounce_flag">
            <a-input-number v-model="bounceModal.value" :min="0" />
          </a-form-model-item>
        </a-form-model>
      </div>
      <template slot="footer">
        <div class="clearfix">
          <div class="float-right">
            <a-button key="back" @click="handleCancelBounce">
              キャンセル
            </a-button>
            <a-button key="submit" type="primary" :loading="bounceModal.loading" @click="handleOkBounceUpdate">
              更新する
            </a-button>
          </div>
        </div>
      </template>
    </a-modal>
  </div>
</template>

<style lang="scss" module>
@import '@/assets/styles/mixins.scss';
.list-name {
  font-size: 1.5rem;
}
</style>
<script>

import Vue from 'vue'
import jaJa from 'ant-design-vue/es/locale/ja_JP'

export default {
  name: 'FormUser',
  data() {
    return {
      locale: jaJa,
      loading: false,
      userId: null,
      user: [],
      gotUserId: 0,
      newStr: '',

      userInfoUpdateType: 0,
      userInfoTargetId: null,
      changeUserInfo: 'メールアドレス変更',
      changeUserLabel: 'メールアドレス',
      visibleUserInfo: false,
      confirmUserInfoUpdateLoading: false,

      emailQuery: '',
      emailSearchLoading: false,
      emailSearchDone: false,
      emailResult: {
        user: null,
        notice_email_address: null,
      },

      bounceModal: {
        visible: false,
        loading: false,
        value: 0,
        targetType: '',
        targetId: null,
      },
    }
  },
  methods: {
    searchUser() {
      this.loading = true
      const userSearch = Vue.prototype.$api.send('get', 'master/users/' + this.userId)
      userSearch.then(response => {
        this.loading = false
        this.user = response
        this.gotUserId = response.id
      })
        .catch(error => {
          this.$notification['error']({
            message: error.status + ': ユーザーの取得に失敗しました。',
          })
          this.loading = false
        })
    },
    openUserInfoModal(type, targetUser) {
      this.newStr = ''
      this.userInfoTargetId = targetUser.id
      if (type === 1) {
        this.changeUserInfo = 'メールアドレス変更'
        this.changeUserLabel = 'メールアドレス'
        this.userInfoUpdateType = 1
        this.newStr = targetUser.email
      } else if (type === 2) {
        this.changeUserInfo = 'パスワード変更'
        this.changeUserLabel = 'パスワード'
        this.userInfoUpdateType = 2
      }
      this.visibleUserInfo = true
    },
    handleCancelUserInfo() {
      this.visibleUserInfo = false
      this.userInfoUpdateType = 0
      this.userInfoTargetId = null
    },
    handleOkUserInfoUpdate() {
      this.confirmUserInfoUpdateLoading = true
      const _this = this
      if (!this.newStr) {
        _this.$notification['error']({
          message: '値が入力されていません。',
        })
        this.confirmUserInfoUpdateLoading = false
        return
      }
      if (this.userInfoUpdateType === 0) {
        _this.$notification['error']({
          message: 'エラーが発生しました。もう一度やり直しください。',
        })
        this.confirmUserInfoUpdateLoading = false
        return
      }
      const typePath = ['', 'email', 'password']
      const targetId = this.userInfoTargetId
      const userSearch = Vue.prototype.$api.send('put', 'master/users/' + targetId + '/' + typePath[this.userInfoUpdateType], { newstr: this.newStr })
      userSearch.then(response => {
        this.confirmUserInfoUpdateLoading = false
        // ユーザーID検索結果の更新
        if (this.gotUserId && response.id === this.gotUserId) {
          this.user = response
        }
        // メール検索結果の更新
        if (this.emailResult.user && response.id === this.emailResult.user.id) {
          this.emailResult = { ...this.emailResult, user: response }
        }
        _this.$notification['success']({
          message: '更新しました。',
        })
        this.handleCancelUserInfo()
      })
        .catch(error => {
          if (error.status === 409) {
            _this.$notification['error']({
              message: error.data.data,
            })
          } else {
            this.$notification['error']({
              message: error.status + ': 更新に失敗しました',
            })
          }
          this.confirmUserInfoUpdateLoading = false
        })
    },
    searchByEmail() {
      if (!this.emailQuery) {
        this.$notification['error']({ message: 'メールアドレスを入力してください。' })
        return
      }
      this.emailSearchLoading = true
      this.emailSearchDone = false
      Vue.prototype.$api.send('get', 'master/search-by-email', { email: this.emailQuery })
        .then(response => {
          this.emailSearchLoading = false
          this.emailResult = {
            user: response.user || null,
            notice_email_address: response.notice_email_address || null,
          }
          this.emailSearchDone = true
        })
        .catch(error => {
          this.$notification['error']({
            message: error.status + ': 検索に失敗しました。',
          })
          this.emailSearchLoading = false
        })
    },
    openBounceModal(targetType, targetId, currentValue) {
      this.bounceModal = {
        visible: true,
        loading: false,
        value: currentValue || 0,
        targetType: targetType,
        targetId: targetId,
      }
    },
    handleCancelBounce() {
      this.bounceModal = { visible: false, loading: false, value: 0, targetType: '', targetId: null }
    },
    handleOkBounceUpdate() {
      const _this = this
      this.bounceModal.loading = true
      let apiPath
      if (this.bounceModal.targetType === 'user') {
        apiPath = 'master/users/' + this.bounceModal.targetId + '/bounce'
      } else {
        apiPath = 'master/notice-email-addresses/' + this.bounceModal.targetId + '/bounce'
      }
      Vue.prototype.$api.send('put', apiPath, { bounce_flag: this.bounceModal.value })
        .then(response => {
          this.bounceModal.loading = false
          // 各表示を更新
          if (this.bounceModal.targetType === 'user') {
            if (this.gotUserId && response.id === this.gotUserId) {
              this.user = response
            }
            if (this.emailResult.user && response.id === this.emailResult.user.id) {
              this.emailResult = { ...this.emailResult, user: response }
            }
          } else {
            if (this.emailResult.notice_email_address && response.id === this.emailResult.notice_email_address.id) {
              this.emailResult = { ...this.emailResult, notice_email_address: response }
            }
          }
          _this.$notification['success']({ message: 'bounce_flag を更新しました。' })
          this.handleCancelBounce()
        })
        .catch(error => {
          _this.$notification['error']({
            message: error.status + ': bounce_flag の更新に失敗しました。',
          })
          this.bounceModal.loading = false
        })
    },
  },
  created() {
  },
}
</script>
